import { flow, Instance, SnapshotIn, types } from 'mobx-state-tree';
import { UserImageAdded, UserImageUpdated } from '@photosi/expo-photosi-sdk/build/UserImage';
import { BaseModel } from './_base/baseModel';
import { LookupCodes } from '../../constants/lookup.constants';
import { logSDKError } from 'src/_shared/logger';

export const LookupOptionModel = BaseModel.named('LookupOption')
  .props({
    identifier: types.identifier,
    id: types.string,
    productId: types.string,
    title: types.string, // @deprecated use titleKey instead
    titleKey: types.string,
    formattedPrice: types.maybe(types.string),
    selected: types.boolean, // @deprecated use isSelected instead
    isSelected: types.boolean,
    previewImageUrl: types.string,
    productConfigurationId: types.string, // @deprecated use value instead
    value: types.string,
    isCustom: types.optional(types.boolean, false),
    lookupCode: types.string,
    disabled: types.optional(types.boolean, false),
  })
  .volatile<{
    isSuboptimal: boolean;
  }>(self => ({
    isSuboptimal: false,
  }))
  .actions(self => ({
    setIsSuboptimal(isSuboptimal: boolean) {
      self.isSuboptimal = isSuboptimal;
    },
    setIsSelected(isSelected: boolean) {
      self.selected = isSelected;
      self.isSelected = isSelected;
    },
    /* 
    TODO: handle this function when refactoring the applyLookup and the product store
    applyLookup() {
      //Datadog.startMeasure(DATADOG_CUSTOM_ACTIONS.configuration_option_apply_time);
      // add opacity
      //self.isUpdating = true;
      // apply changes on SDK
      return self.sdkProject.replaceProduct(self.productId, self.productConfigurationId).catch(error => {
        logSDKError(error, { productId: self.productId, productConfigurationId: self.productConfigurationId });
      });
    }, */
  }));

export const LookupModel = BaseModel.named('LookupModel')
  .props({
    identifier: types.identifier,
    code: types.string,
    options: types.array(LookupOptionModel),
    productId: types.string,
    description: types.optional(types.string, ''),
    isCustom: types.optional(types.boolean, false),
  })

  .actions(self => {
    const getQualitySuitableFormats = flow(function* getQualitySuitableFormats() {
      let formats;
      if (self.code === 'format') {
        try {
          let formats = yield self
            .awaitSdkProject()
            .then(() => self.sdkProject.getQualitySuitableFormats(self.productId));
          if (formats) {
            self.options.forEach(option => {
              option.setIsSuboptimal(!formats.suitableFormats.includes(option.id));
            });
          }
        } catch (err) {
          logSDKError(err, { productId: self.productId });
        }
      }
      return formats;
    });

    const syncBorderTypeSelection = (userImageEvent: UserImageAdded | UserImageUpdated) => {
      if (self.code !== LookupCodes.BORDER_TYPE) return;

      self.options.forEach(option => {
        option.setIsSelected(option.value === userImageEvent.transformations.borderType);
      });
    };

    return {
      getQualitySuitableFormats,
      syncBorderTypeSelection,
    };
  });

export interface ILookupModel extends Instance<typeof LookupModel> {}

export interface ILookupModelIn extends SnapshotIn<typeof LookupModel> {}
export interface ILookupOptionModel extends Instance<typeof LookupOptionModel> {}

export interface ILookupOptionModelIn extends SnapshotIn<typeof LookupOptionModel> {}
